<template>
    <div class="lots-step" data-cy="reserve_step_lots">
        <section class="lots-step__hero">
            <div>
                <span class="lots-step__eyebrow">Etapa 2</span>
                <h4 class="lots-step__title">Escolha o lote ideal para esta reserva</h4>
                <p class="lots-step__description">
                    Exibimos somente lotes disponiveis. Use a quadra e os destaques para encontrar rapidamente a melhor
                    opcao.
                </p>
            </div>

            <div class="lots-step__summary">
                <div>
                    <strong>{{ countAllLots() }}</strong>
                    <span>disponiveis</span>
                </div>
                <div>
                    <strong>{{ Object.values(blocksAvailableResume).length }}</strong>
                    <span>quadras</span>
                </div>
            </div>
        </section>

        <section class="lots-step__filters">
            <div class="lots-step__block-picker">
                <div class="lots-step__filter-heading">
                    <span>1</span>
                    <div>
                        <strong>Selecione a quadra</strong>
                        <small>Depois exibimos somente os lotes disponiveis dessa quadra.</small>
                    </div>
                </div>

                <div class="lots-step__blocks" aria-label="Quadras disponiveis">
                    <button v-for="block in blocksAvailable" :key="block.id" class="lots-step__block"
                            :class="{'lots-step__block--active': block.active}"
                            type="button" @click="changeBlock(block.text)">
                        <strong>{{ block.text }}</strong>
                        <small>{{ blocksAvailableResume[block.text].total_lote }} {{
                                block.lots === 1 ? 'lote' : 'lotes'
                            }}</small>
                    </button>
                </div>
            </div>

            <div class="lots-step__lot-filter">
                <div class="lots-step__filter-heading">
                    <span>2</span>
                    <div>
                        <strong>Filtre os lotes da quadra 001</strong>
                        <small>Opcional. Use quando houver muitos lotes disponiveis na quadra.</small>
                    </div>
                </div>

                                        <div class="lots-step__filter-fields">
                                            <div class="lots-step__search">
                                                <i class="icon-search"></i>
                                                <input type="text"
                                                       v-model="filters.lot"
                                                       placeholder="Lote"
                                                       @input="applyLotFilters">
                                            </div>
                                            <div class="lots-step__search">
                                                <i class="icon-ruler"></i>
                                                <input type="text"
                                                       v-model="filters.area"
                                                       placeholder="Metragem"
                                                       @input="applyLotFilters">
                                            </div>
                                            <div class="lots-step__search">
                                                <i class="icon-local_atm"></i>
                                                <input type="text"
                                                       v-model="filters.price"
                                                       placeholder="Valor"
                                                       @input="applyLotFilters">
                                            </div>
                                        </div>
                                    </div>
                                </section>
        <div class="lots-step__layout">
            <section class="lots-step__grid" aria-label="Lotes disponiveis">
                <article v-for="(lot, k) in propertiesAvailable" :key="k" class="lots-step__lot-card"
                         :class="{'lots-step__lot-card--highlight': lot.highlight, 'lots-step__lot-card--selected': lotSelected.id === lot.id}"
                         @click="selectLot(lot)">
                    <div class="lots-step__lot-topline">
                        <span class="lots-step__status">Disponível</span>
                        <span class="lots-step__block-label">Quadra {{ lot.block }}</span>
                    </div>
                    <div class="lots-step__lot-main">
                        <h5>Lote {{ lot.text }}</h5>
                        <strong>{{ formatPrice(lot.price) }}</strong>
                    </div>
                    <div class="lots-step__lot-metrics">
                        <span><b>{{ lot.total_area ? `${lot.total_area}m²` : '-' }}</b> area total</span>
                        <span><b>{{ lot.front_size ? `${lot.front_size}m` : '-' }}</b> frente</span>
                        <span><b>{{ lot.back_size ? `${lot.back_size}m` : '-' }}</b> fundo</span>
                    </div>
                    <button class="lots-step__select-button" type="button" @click.stop="selectLot(lot)">
                        {{ lotSelected.id === lot.id ? 'Selecionado' : 'Selecionar' }}
                    </button>
                </article>
            </section>

            <aside class="lots-step__selected-panel">
                <div class="lots-step__empty-selection" v-if="!lotSelected.id">
                    <div class="lots-step__empty-icon">
                        <i class="icon-map2"></i>
                    </div>
                    <span class="lots-step__eyebrow">Lote selecionado</span>
                    <h5>Nenhum lote selecionado</h5>
                    <div class="lots-step__empty-hint">Selecione um card ao lado para preencher este espaco.</div>
                </div>

                <div v-if="lotSelected.id">
                    <h5>Quadra {{ lotSelected.block }} · Lote {{ lotSelected.text }}</h5>
                    <p>Boa escolha para reserva!</p>

                    <div class="lots-step__selected-map">
                        <span>{{ lotSelected.block }}-{{ lotSelected.text }}</span>
                    </div>

                    <div class="lots-step__selected-details">
                        <div>
                            <small>Area total</small>
                            <strong>{{ lotSelected.total_area ? `${lotSelected.total_area}m²` : '-' }}</strong>
                        </div>
                        <div>
                            <small>Valor</small>
                            <strong>{{ formatPrice(lotSelected.price) }}</strong>
                        </div>
                        <div>
                            <small>Status</small>
                            <strong>Disponível</strong>
                        </div>
                    </div>
                </div>
            </aside>
        </div>
    </div>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex';

export default {
    name: 'ReserveStepLots',
    data() {
        return {
            blocks: [
                {id: '001', lots: 6, active: true},
                {id: '002', lots: 5},
                {id: '003', lots: 4},
                {id: 'BC003', lots: 3},
                {id: 'BC004', lots: 2},
                {id: 'C0010', lots: 4},
                {id: 'D012', lots: 1},
                {id: 'E100', lots: 2},
                {id: 'F020', lots: 3},
                {id: 'G001', lots: 1},
            ],
            lots: [
                {
                    name: 'Lote 00012',
                    price: 'R$ 184.000,00',
                    area: '250m²',
                    front: '10m',
                    back: '25m',
                    label: 'Quadra 001'
                },
                {
                    name: 'Lote 00014',
                    price: 'R$ 171.500,00',
                    area: '235m²',
                    front: '9,4m',
                    back: '25m',
                    label: 'Quadra 001'
                },
                {
                    name: 'Lote 00015',
                    price: 'R$ 219.000,00',
                    area: '312m²',
                    front: '14m',
                    back: '22m',
                    label: 'Esquina',
                    highlight: true
                },
                {
                    name: 'Lote 00018',
                    price: 'R$ 163.900,00',
                    area: '225m²',
                    front: '9m',
                    back: '25m',
                    label: 'Quadra 001'
                },
            ],
            lotSelected: {},
            filters: {
                lot: '',
                area: '',
                price: '',
            },
        };
    },
    computed: {
        ...mapState({
            blocksAvailable: (state) => state.reserve.blocksAvailable,
            blocksAvailableResume: (state) => state.reserve.blocksAvailableResume,
            propertiesAvailable: (state) => state.reserve.propertiesAvailable,
            propertiesAvailableBackup: (state) => state.reserve.propertiesAvailableBackup,
        })
    },
    methods: {
        ...mapActions({showLotPropertiesAvailableAction: 'showLotPropertiesAvailableAction'}),
        ...mapMutations({
            changeblocksAvailableMutation: 'changeblocksAvailableMutation',
            filterPropertiesAvailableMutation: 'filterPropertiesAvailableMutation',
        }),
        countAllLots() {
            let total = 0;
            Object.entries(this.blocksAvailableResume).forEach(([k]) => {
                total = (total + this.blocksAvailableResume[k].total_lote)
            });
            return total;
        },
        formatPrice(price) {
            if (price === null) return 'Indisponível';
            return Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(price);
        },
        selectLot(lot) {
            this.lotSelected = lot;
        },
        normalizeFilter(value) {
            return String(value || '').toLowerCase().replace(/\s/g, '').replace(',', '.');
        },
        onlyNumbers(value) {
            return String(value || '').replace(/\D/g, '');
        },
        applyLotFilters() {
            const lotFilter = this.normalizeFilter(this.filters.lot);
            const areaFilter = this.normalizeFilter(this.filters.area).replace('m²', '').replace('m2', '').replace('m', '');
            const priceFilter = this.onlyNumbers(this.filters.price);

            const filtered = this.propertiesAvailableBackup.filter(lot => {
                const lotText = this.normalizeFilter(lot.text || lot.name);
                const areaText = this.normalizeFilter(lot.total_area);
                const priceText = this.onlyNumbers(lot.price);

                const matchesLot = !lotFilter || lotText.includes(lotFilter);
                const matchesArea = !areaFilter || areaText.includes(areaFilter);
                const matchesPrice = !priceFilter || priceText.includes(priceFilter);

                return matchesLot && matchesArea && matchesPrice;
            });

            this.filterPropertiesAvailableMutation(filtered);
        },
        resetLotFilters() {
            this.filters = {
                lot: '',
                area: '',
                price: '',
            };
        },
        changeBlock(block) {
            this.$store.commit('changeLoading', true);
            this.lotSelected = {};
            this.resetLotFilters();
            this.changeblocksAvailableMutation(block);
            this.showLotPropertiesAvailableAction({
                blockId: block,
                withInfos: true,
                withLoad: true,
            });
        }
    }
};
</script>

<style scoped>
.lots-step {
    display: grid;
    gap: 1rem;
}

.lots-step__hero {
    align-items: center;
    background: radial-gradient(circle at 88% 18%, rgba(14, 94, 78, .16), transparent 30%),
    linear-gradient(135deg, #ffffff 0%, #f3f8f7 52%, #edf5f2 100%);
    border: 1px solid #dce8e5;
    border-radius: 20px;
    box-shadow: 0 14px 34px rgba(39, 52, 63, .07);
    display: grid;
    gap: 1rem;
    grid-template-columns: minmax(0, 1fr) auto;
    padding: 1.15rem 1.25rem;
}

.lots-step__eyebrow {
    color: #0e5e4e;
    display: block;
    font-size: .66rem;
    font-weight: 900;
    letter-spacing: .1rem;
    margin-bottom: .38rem;
    text-transform: uppercase;
}

.lots-step__title {
    color: #27343f;
    font-size: 1.22rem;
    font-weight: 900;
    letter-spacing: -.02rem;
    line-height: 1.15;
    margin-bottom: .32rem;
}

.lots-step__description {
    color: #68747f;
    font-size: .84rem;
    line-height: 1.42;
    margin: 0;
    max-width: 680px;
}

.lots-step__summary {
    display: grid;
    gap: .5rem;
    grid-template-columns: repeat(2, 96px);
}

.lots-step__summary div {
    background: rgba(255, 255, 255, .75);
    border: 1px solid rgba(14, 94, 78, .12);
    border-radius: 15px;
    padding: .62rem;
    text-align: center;
}

.lots-step__summary strong {
    color: #0e5e4e;
    display: block;
    font-size: 1.1rem;
    font-weight: 900;
    line-height: 1;
}

.lots-step__summary span {
    color: #697681;
    display: block;
    font-size: .64rem;
    font-weight: 800;
    margin-top: .28rem;
    text-transform: uppercase;
}

.lots-step__filters {
    background: #fff;
    border: 1px solid #e2e9ee;
    border-radius: 22px;
    box-shadow: 0 12px 30px rgba(39, 52, 63, .05);
    display: grid;
    gap: .75rem;
    grid-template-columns: 1fr;
    padding: .75rem;
}

.lots-step__block-picker,
.lots-step__lot-filter {
    display: grid;
    gap: .65rem;
}

.lots-step__lot-filter {
    background: #f8fbfa;
    border: 1px solid #e4ecea;
    border-radius: 18px;
    display: grid;
    gap: .65rem;
    grid-template-columns: 1fr;
    padding: .75rem;
}

.lots-step__filter-fields {
    display: grid;
    gap: .55rem;
    grid-template-columns: repeat(3, minmax(0, 1fr));
}

.lots-step__filter-heading {
    align-items: center;
    display: flex;
    gap: .6rem;
}

.lots-step__filter-heading > span {
    align-items: center;
    background: #0e5e4e;
    border-radius: 12px;
    color: #fff;
    display: flex;
    flex: 0 0 32px;
    font-size: .82rem;
    font-weight: 900;
    height: 32px;
    justify-content: center;
}

.lots-step__filter-heading strong {
    color: #27343f;
    display: block;
    font-size: .88rem;
    font-weight: 900;
}

.lots-step__filter-heading small {
    color: #7a8792;
    display: block;
    font-size: .72rem;
    font-weight: 700;
    line-height: 1.35;
}

.lots-step__search {
    align-items: center;
    background: #f7faf9;
    border: 1px solid #dfe8e6;
    border-radius: 14px;
    color: #0e5e4e;
    display: flex;
    gap: .75rem;
    min-height: 40px;
    padding: 0 .75rem;
}

.lots-step__search input {
    background: transparent;
    border: 0;
    color: #27343f;
    flex: 1;
    font-weight: 700;
    min-width: 0;
    outline: none;
}

.lots-step__blocks {
    display: flex;
    gap: .6rem;
    overflow-x: auto;
    overflow-y: hidden;
    padding: .1rem .25rem .1rem .1rem;
}

.lots-step__block {
    align-items: flex-start;
    background: #f5f8f8;
    border: 1px solid #dfe8e6;
    border-radius: 14px;
    color: #52606b;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    flex: 0 0 96px;
    gap: .25rem;
    min-height: 62px;
    padding: .58rem .65rem;
    text-align: left;
    transition: border-color .2s ease, box-shadow .2s ease, transform .2s ease;
}

.lots-step__block:hover {
    border-color: rgba(14, 94, 78, .24);
    box-shadow: 0 10px 20px rgba(39, 52, 63, .06);
    transform: translateY(-1px);
}

.lots-step__block strong {
    color: #27343f;
    font-size: .9rem;
    font-weight: 900;
    letter-spacing: .02rem;
}

.lots-step__block small {
    color: #7d8993;
    font-size: .68rem;
    font-weight: 800;
}

.lots-step__block--active {
    background: #0e5e4e;
    border-color: #0e5e4e;
    color: #fff;
    box-shadow: 0 10px 22px rgba(14, 94, 78, .18);
}

.lots-step__block--active strong,
.lots-step__block--active small {
    color: #fff;
}

.lots-step__layout {
    align-items: start;
    display: grid;
    gap: 1rem;
    grid-template-columns: minmax(0, 1fr) 300px;
}

.lots-step__grid {
    display: grid;
    gap: .8rem;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
}

.lots-step__lot-card,
.lots-step__selected-panel {
    background: #fff;
    border: 1px solid #e2e9ee;
    border-radius: 22px;
    box-shadow: 0 14px 34px rgba(39, 52, 63, .06);
}

.lots-step__lot-card {
    cursor: pointer;
    overflow: hidden;
    padding: .78rem;
    position: relative;
    transition: background .2s ease, border-color .2s ease, box-shadow .2s ease, transform .2s ease;
}

.lots-step__lot-card:hover {
    background: linear-gradient(180deg, #f7fcfa 0%, #ffffff 62%);
    border-color: rgba(14, 94, 78, .35);
    box-shadow: 0 18px 38px rgba(14, 94, 78, .12);
    transform: translateY(-2px);
}

.lots-step__lot-card--selected {
    background: linear-gradient(180deg, #f0faf7 0%, #ffffff 70%);
    border-color: rgba(14, 94, 78, .35);
    box-shadow: 0 18px 42px rgba(14, 94, 78, .16);
    transform: translateY(-2px);
}

.lots-step__lot-card--selected:before {
    background: linear-gradient(135deg, #0e5e4e, #128a72);
    content: "";
    inset: 0 auto 0 0;
    position: absolute;
    width: 5px;
}

.lots-step__lot-card--highlight {
    background: linear-gradient(180deg, rgba(255, 246, 223, .55), transparent 55%),
    #fff;
}

.lots-step__lot-topline,
.lots-step__lot-main {
    align-items: center;
    display: flex;
    justify-content: space-between;
}

.lots-step__status,
.lots-step__block-label {
    border-radius: 999px;
    font-size: .66rem;
    font-weight: 900;
    padding: .25rem .48rem;
}

.lots-step__status {
    background: #e7f5ef;
    color: #0e5e4e;
}

.lots-step__block-label {
    background: #f2f5f7;
    color: #65717c;
}

.lots-step__lot-main {
    margin-top: .72rem;
}

.lots-step__lot-main h5 {
    color: #27343f;
    font-size: 1.05rem;
    font-weight: 900;
    margin: 0;
}

.lots-step__lot-main strong {
    color: #0e5e4e;
    font-size: .86rem;
    font-weight: 900;
}

.lots-step__lot-metrics {
    display: grid;
    gap: .4rem;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    margin: .72rem 0;
}

.lots-step__lot-metrics span {
    background: #f7faf9;
    border-radius: 12px;
    color: #7a8792;
    font-size: .65rem;
    font-weight: 800;
    padding: .48rem;
}

.lots-step__lot-metrics b {
    color: #34414d;
    display: block;
    font-size: .78rem;
    margin-bottom: .12rem;
}

.lots-step__select-button {
    background: #edf5f3;
    border: 0;
    border-radius: 14px;
    color: #0e5e4e;
    cursor: pointer;
    font-weight: 900;
    min-height: 36px;
    transition: background .2s ease, box-shadow .2s ease, color .2s ease, transform .2s ease;
    width: 100%;
}

.lots-step__lot-card:hover .lots-step__select-button {
    background: #dff2ec;
    box-shadow: inset 0 0 0 1px rgba(14, 94, 78, .16);
    color: #0e5e4e;
    transform: translateY(-1px);
}

.lots-step__select-button:hover,
.lots-step__select-button:focus {
    background: #dff2ec;
    color: #0e5e4e;
    outline: none;
}

.lots-step__lot-card--selected .lots-step__select-button {
    background: linear-gradient(135deg, #0e5e4e, #128a72);
    box-shadow: 0 10px 22px rgba(14, 94, 78, .2);
    color: #fff;
}

.lots-step__lot-card--selected .lots-step__select-button:hover,
.lots-step__lot-card--selected .lots-step__select-button:focus {
    background: linear-gradient(135deg, #0e5e4e, #128a72);
    color: #fff;
}

.lots-step__selected-panel {
    padding: 1.15rem;
    position: sticky;
    top: 1rem;
}

.lots-step__selected-panel h5 {
    color: #27343f;
    font-size: 1.05rem;
    font-weight: 900;
    margin: 0 0 .45rem;
}

.lots-step__selected-panel p {
    color: #72808b;
    font-size: .84rem;
    line-height: 1.5;
    margin-bottom: 1rem;
}

.lots-step__empty-selection {
    align-items: center;
    display: flex;
    flex-direction: column;
    min-height: 360px;
    justify-content: center;
    text-align: center;
}

.lots-step__empty-icon {
    align-items: center;
    background: #edf5f3;
    border-radius: 24px;
    color: #0e5e4e;
    display: flex;
    font-size: 2rem;
    height: 88px;
    justify-content: center;
    margin-bottom: 1rem;
    width: 88px;
}

.lots-step__empty-hint {
    background: #f7faf9;
    border: 1px dashed #cddbd8;
    border-radius: 16px;
    color: #60707b;
    font-size: .8rem;
    font-weight: 800;
    line-height: 1.35;
    padding: .75rem .9rem;
}

.lots-step__selected-example {
    border-top: 1px solid #edf2f4;
    margin-top: 1.1rem;
    padding-top: 1.1rem;
}

.lots-step__example-label {
    background: #fff6df;
    border-radius: 999px;
    color: #8a6200;
    display: inline-flex;
    font-size: .68rem;
    font-weight: 900;
    letter-spacing: .05rem;
    margin-bottom: .75rem;
    padding: .35rem .65rem;
    text-transform: uppercase;
}

.lots-step__selected-map {
    align-items: center;
    background: linear-gradient(90deg, rgba(255, 255, 255, .12) 1px, transparent 1px),
    linear-gradient(0deg, rgba(255, 255, 255, .12) 1px, transparent 1px),
    linear-gradient(135deg, #0e5e4e, #1aa887);
    background-size: 22px 22px, 22px 22px, auto;
    border-radius: 20px;
    color: #fff;
    display: flex;
    font-size: 2rem;
    font-weight: 900;
    height: 160px;
    justify-content: center;
    margin-bottom: 1rem;
}

.lots-step__selected-details {
    display: grid;
    gap: .65rem;
}

.lots-step__selected-details div {
    align-items: center;
    background: #f7faf9;
    border-radius: 14px;
    display: flex;
    justify-content: space-between;
    padding: .72rem .85rem;
}

.lots-step__selected-details small {
    color: #7d8993;
    font-size: .74rem;
    font-weight: 900;
    text-transform: uppercase;
}

.lots-step__selected-details strong {
    color: #27343f;
    font-size: .86rem;
    font-weight: 900;
}

@media (max-width: 900px) {
    .lots-step__hero,
    .lots-step__filters,
    .lots-step__layout {
        grid-template-columns: 1fr;
    }

    .lots-step__lot-filter {
        grid-template-columns: 1fr;
    }

    .lots-step__summary {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .lots-step__grid {
        grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
    }

    .lots-step__blocks {
        max-height: none;
    }

    .lots-step__selected-panel {
        position: static;
    }
}

@media (max-width: 576px) {
    .lots-step__summary,
    .lots-step__lot-metrics,
    .lots-step__filter-fields {
        grid-template-columns: 1fr;
    }

    .lots-step__grid {
        grid-template-columns: 1fr;
    }

    .lots-step__summary div {
        text-align: left;
    }

    .lots-step__lot-main {
        align-items: flex-start;
        flex-direction: column;
        gap: .35rem;
    }
}
</style>
